/**
 * Whether the companion is on (buddy cursor follows the mouse, Ctrl+Alt
 * hold-to-talk works). The source of truth for the overlay's on/off: the
 * overlay's double-tap of the Ctrl+Alt chord and the chat window's speech
 * button both write here, and app-layout feeds it back to the overlay.
 *
 * Panel audio (scanner alerts, the news readout) subscribes to mute while the
 * companion is on.
 *
 * Module-level store rather than context on purpose: this flips on every
 * companion open/close, and putting it in a provider would re-render the
 * whole tree under it just to mute a queue.
 */
import { useSyncExternalStore } from 'react'

let active = false
const listeners = new Set<() => void>()

/** Turn the companion on or off. */
export function setCompanionActive(next: boolean): void {
  if (active === next) return
  active = next
  for (const listener of listeners) listener()
}

export function getCompanionActive(): boolean {
  return active
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Subscribe to companion activity, to duck or mute panel audio while it talks. */
export function useCompanionActive(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => active,
    () => false,
  )
}

/** Test seam. */
export function resetCompanionActiveStore(): void {
  active = false
  listeners.clear()
}
